import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    top: 70;
    width: 100vw;
    max-width: 500px;
    height: calc(100% - 140px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export {
    Container
}